import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { RequestService } from './request.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    // public showNotificationUnRead: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public dnd: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
    public refreshData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public unread: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    public unreadCleared: Subject<string | null> = new Subject<string | null>();
    public isThreatMuted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private db: any = undefined;

    constructor(private snackBar: MatSnackBar, private requestService: RequestService) { }

    public openSnackBar(message: string) {
        this.snackBar.open(message, '', {
            duration: 5000
        });
    }

    getNotifications(term: string, pageIndex: number, pageSize: number, caseId?: string, excludeTypes?): Promise<void> {
        let filter: any = {
            "$and": [
                { "organizationId._id": { "$eq": this.requestService.orgId } },
                { "type": { "$nin": excludeTypes } } // we exclude assign case and request camera
            ]
        };
        let currentUser = this.requestService.currentUser;
        let isSuperAdmin = this.requestService.isUserRoleSuperAdmin();
        let isInvestigator = this.requestService.isUserRoleInvestigator();
        if (currentUser) {
            if (isSuperAdmin) {
                // nothing
            } else {
                if (isInvestigator) {
                    filter["$and"].push(
                        { "investigators._id": { "$in": [currentUser._id] } }
                    );
                } else {
                    if (currentUser['prefecture']) {
                        filter['$and'].push({ "prefecture": { "$eq": currentUser['prefecture'] } });
                    }
                    if (currentUser['region']) {
                        filter['$and'].push({ "region": { "$eq": currentUser['region'] } });
                    }
                    // filter["$and"].push(
                    //     { "users": { "$size": 0 } }
                    // );
                }
            }
        }

        if (caseId) {
            filter["$and"].push(
                { "case._id": { "$eq": caseId } }
            );
        }

        return new Promise((resolve, reject) => {
            this.requestService.getDataList('notify', {
                term: term || '', termfields: ['message', 'user.name', 'createdName', 'location', 'case.name'], page: pageIndex + 1, perpage: pageSize, filter: filter, orderBy: 'updatedAt', orderDir: 'desc', fieldKeys: ['message', 'title', 'type', 'case', 'note', 'document', 'user', 'createdName', 'location', 'geolocation', 'updatedAt', 'investigators', 'investigatorgroup', 'description', 'createdAt', 'prefecture', 'region', 'threat_type', 'threat_types']
            }, (data: any, error: any) => {
                if (data) {
                    resolve(data);
                }
                else if (error) {
                    reject(error);
                }
            });
        });
    }

    async markAsRead(currentUserId, options: { caseId?: string, notificationId?: string, ids?: string[] } = {}) {
        const unreadGroups = this.unread.getValue() || [];
        let newUnreadGroups = [];
        let payload: any = { userId: currentUserId };

        if (options.caseId) {
            // Remove the group with this caseId
            newUnreadGroups = unreadGroups.filter(g => g.caseId !== options.caseId);
            payload.caseId = options.caseId;
        } else if (options.ids) {
            // Assume marking "Unrelated" group or specific list
            // For "Unrelated", caseId is null.
            // We remove the group that has these ids (or overlaps significantly)
            // Simpler: filter out groups where we are marking all their ids
            newUnreadGroups = unreadGroups.filter(g => {
                // If group ids are subset of options.ids, remove group
                if (!g.caseId && g.ids.every(id => options.ids.includes(id))) return false;
                return true;
            });
            payload.ids = options.ids;
        } else if (options.notificationId) {
            // Find group containing this ID, remove ID, decrement count
            newUnreadGroups = unreadGroups.map(g => {
                if (g.ids && g.ids.includes(options.notificationId)) {
                    const newIds = g.ids.filter(id => id !== options.notificationId);
                    return { ...g, ids: newIds, count: newIds.length };
                }
                return g;
            }).filter(g => g.count > 0);
            payload.ids = [options.notificationId];
        } else {
            // Mark all
            newUnreadGroups = [];
        }

        this.unread.next(newUnreadGroups);
        this.unreadCleared.next(options.caseId || null);

        let url = environment.serverUrl + 'notify/markAsRead';
        url = this.requestService.addLanguageToURL(url, environment.lang);

        this.requestService.jsonRequest(url, (data, error) => {
            if (error) console.error(error);
        }, 'POST', payload);
    }

    getUnreadNotifications() {
        const orgId = this.requestService.orgId;
        if (!orgId) return;

        let url = environment.serverUrl + `notify/unread/grouped/${orgId}`;
        url = this.requestService.addLanguageToURL(url, environment.lang);

        this.requestService.jsonGetRequest(url, (data, error) => {
            if (data && data.results) {
                this.unread.next(data.results);
            } else if (error) {
                console.error("Failed to fetch unread notifications", error);
            }
        });
    }
}
